'use client';

import React from 'react';
import { Skeleton, Text } from '@instamenu/ui-system-next';
import * as styles from './delivery-pickup-toggle.css';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { Fulfillment } from '@instamenu/data-access';
import { observer } from 'mobx-react-lite';

export const DeliveryPickupToggle = observer(
  ({ deliveryEnabled }: { deliveryEnabled?: boolean }) => {
    const checkout = useCheckoutContext();

    if (!checkout && deliveryEnabled) {
      return (
        <div className={styles.toggleContainer}>
          <Skeleton variant="rect" className={styles.skeletonStyles} />
        </div>
      );
    }

    if (!checkout?.mode) return null;

    const handleSelect = (option: Fulfillment) => {
      checkout.mode = option;
      if (checkout.order.id) {
        checkout.order.updateFulfillment(option);
      }
    };

    return (
      <div className={styles.toggleContainer}>
        <div className={`${styles.slider} ${styles.sliderAnimation[checkout.mode]}`} />
        <button
          className={
            styles.toggleOption[checkout.mode === Fulfillment.Delivery ? 'selected' : 'unselected']
          }
          onClick={() => handleSelect(Fulfillment.Delivery)}
        >
          <Text>Delivery</Text>
        </button>
        <button
          className={
            styles.toggleOption[checkout.mode === Fulfillment.Pickup ? 'selected' : 'unselected']
          }
          onClick={() => handleSelect(Fulfillment.Pickup)}
        >
          <Text>Pickup</Text>
        </button>
      </div>
    );
  },
);
